import React, { useCallback, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { TbArrowsExchange2 } from 'react-icons/tb';

import { ReactComponent as Close } from 'assets/images/close.svg';
import styleGuide from 'constants/styleGuide';
import { STORE_ADDR_TYPE } from 'constants/CONSTATNS';

declare global {
  interface Window {
    kakao: any;
  }
}
const Container = styled.div`
  z-index: 2;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
const Wrap = styled.div`
  z-index: 1;
  position: relative;
  display: flex;
  padding: 60px;
  max-height: 80%;
  border-radius: 16px;
  flex-direction: column;
  background-color: #fff;
`;
export const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
`;
const TitleArea = styled.div`
  text-align: center;
`;
const TitleText = styled.strong`
  font-size: 1.7rem;
`;
const CloseBtn = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  padding: 20px;
`;
const ContentArea = styled.div`
  max-height: 100%;
  overflow-y: auto;
`;

interface IProps {
  isVisible: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

const CommonModal = ({ isVisible, onClose, title, children }: IProps) => {
  if (isVisible === false) return null;
  return (
    <Container>
      <Wrap>
        <TitleArea>
          <TitleText>{title}</TitleText>
        </TitleArea>
        <CloseBtn onClick={onClose}>
          <Close fontSize={10} />
        </CloseBtn>
        <ContentArea>{children}</ContentArea>
      </Wrap>
      <Background onClick={onClose} />
    </Container>
  );
};
export default CommonModal;
